module.exports = __webpack_public_path__ + "static/DWAYNE-ae3c646ce7be8e18ed0a5f0eb5f1ad6e.jpg";